.viewport {
  position: fixed;
  right: var(--space-5);
  bottom: var(--space-5);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(380px, calc(100vw - var(--space-8)));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--bg-surface-raised);
  border: 1px solid var(--border-default);
  border-left-width: 3px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  animation: ela-fade-in var(--duration-normal) var(--ease-out);
}

.success {
  border-left-color: var(--success);
  color: var(--text-primary);
}

.success .icon {
  color: var(--success);
}

.error {
  border-left-color: var(--danger);
}

.error .icon {
  color: var(--danger);
}

.warning {
  border-left-color: var(--warning);
}

.warning .icon {
  color: var(--warning);
}

.info {
  border-left-color: var(--info);
}

.info .icon {
  color: var(--info);
}

.icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.body {
  flex: 1;
  min-width: 0;
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  overflow-wrap: anywhere;
}

.dismiss {
  flex-shrink: 0;
  color: var(--text-tertiary);
  margin-top: 1px;
}

.dismiss:hover {
  color: var(--text-primary);
}

@media (max-width: 640px) {
  .viewport {
    right: var(--space-3);
    left: var(--space-3);
    bottom: var(--space-3);
    width: auto;
  }
}
